import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Conclusionpoint() {
  return (
    <section
      className="conclusion_point p-100 text_white bg_green_color"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="conc_img">
              <StaticImage
                src="../../../images/case-studies/point2-design/conclusion_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={783}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2 style={{ color: "#E8E751" }}>Conclusion</h2>
            <p>
              TekRevol successfully achieved the project's goals with the
              creation of Point 2 Design, by simplifying order management for
              celebrities. The app's key features, including digital signature
              integration and seamless order desk integration, have
              revolutionized the way orders are processed. Point 2 Design stands
              as a testament to TekRevol's commitment to delivering tailored
              solutions that drive automation and efficiency, ultimately
              benefiting businesses and individuals alike in the digital age.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Conclusionpoint;
